import { Action } from 'redux';

import { SpaceType } from '~src/spacesPlatform/state/SpaceInfo';

import { PublishedConnectionCountsRequest } from '../../bootstrap/redux/actions/AppActionTypes';

export interface PublishedConnectionCountsRequestAction extends Action {
  spaceType: SpaceType;
}

export function publishedConnectionCountsRequest(
  spaceType: SpaceType
): PublishedConnectionCountsRequestAction {
  return {
    type: PublishedConnectionCountsRequest,
    spaceType
  };
}
